
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_1h82x_99",
  "box": "awsui_box_18wu0_1h82x_219",
  "p-variant": "awsui_p-variant_18wu0_1h82x_219",
  "color-default": "awsui_color-default_18wu0_1h82x_219",
  "b-variant": "awsui_b-variant_18wu0_1h82x_219",
  "strong-variant": "awsui_strong-variant_18wu0_1h82x_219",
  "code-variant": "awsui_code-variant_18wu0_1h82x_219",
  "pre-variant": "awsui_pre-variant_18wu0_1h82x_219",
  "samp-variant": "awsui_samp-variant_18wu0_1h82x_219",
  "h1-variant": "awsui_h1-variant_18wu0_1h82x_223",
  "h2-variant": "awsui_h2-variant_18wu0_1h82x_223",
  "h3-variant": "awsui_h3-variant_18wu0_1h82x_223",
  "h4-variant": "awsui_h4-variant_18wu0_1h82x_223",
  "h5-variant": "awsui_h5-variant_18wu0_1h82x_223",
  "small-variant": "awsui_small-variant_18wu0_1h82x_227",
  "a-variant": "awsui_a-variant_18wu0_1h82x_231",
  "font-size-default": "awsui_font-size-default_18wu0_1h82x_235",
  "font-weight-default": "awsui_font-weight-default_18wu0_1h82x_275",
  "key-label-variant": "awsui_key-label-variant_18wu0_1h82x_317",
  "value-large-variant": "awsui_value-large-variant_18wu0_1h82x_324",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_1h82x_331",
  "color-inverted": "awsui_color-inverted_18wu0_1h82x_336",
  "color-text-label": "awsui_color-text-label_18wu0_1h82x_339",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_1h82x_342",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_1h82x_345",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_1h82x_348",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_1h82x_351",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_1h82x_354",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_1h82x_357",
  "color-inherit": "awsui_color-inherit_18wu0_1h82x_360",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_1h82x_363",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_1h82x_368",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_1h82x_372",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_1h82x_376",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_1h82x_381",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_1h82x_386",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_1h82x_391",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_1h82x_396",
  "font-weight-light": "awsui_font-weight-light_18wu0_1h82x_401",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_1h82x_404",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_1h82x_407",
  "t-left": "awsui_t-left_18wu0_1h82x_414",
  "t-right": "awsui_t-right_18wu0_1h82x_418",
  "t-center": "awsui_t-center_18wu0_1h82x_422",
  "p-n": "awsui_p-n_18wu0_1h82x_529",
  "p-top-n": "awsui_p-top-n_18wu0_1h82x_533",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_1h82x_534",
  "p-right-n": "awsui_p-right-n_18wu0_1h82x_538",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_1h82x_539",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_1h82x_543",
  "p-left-n": "awsui_p-left-n_18wu0_1h82x_548",
  "p-xxxs": "awsui_p-xxxs_18wu0_1h82x_553",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_1h82x_557",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_1h82x_558",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_1h82x_562",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_1h82x_563",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_1h82x_567",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_1h82x_572",
  "p-xxs": "awsui_p-xxs_18wu0_1h82x_577",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_1h82x_581",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_1h82x_582",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_1h82x_586",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_1h82x_587",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_1h82x_591",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_1h82x_596",
  "p-xs": "awsui_p-xs_18wu0_1h82x_601",
  "p-top-xs": "awsui_p-top-xs_18wu0_1h82x_605",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_1h82x_606",
  "p-right-xs": "awsui_p-right-xs_18wu0_1h82x_610",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_1h82x_611",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_1h82x_615",
  "p-left-xs": "awsui_p-left-xs_18wu0_1h82x_620",
  "p-s": "awsui_p-s_18wu0_1h82x_625",
  "p-top-s": "awsui_p-top-s_18wu0_1h82x_629",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_1h82x_630",
  "p-right-s": "awsui_p-right-s_18wu0_1h82x_634",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_1h82x_635",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_1h82x_639",
  "p-left-s": "awsui_p-left-s_18wu0_1h82x_644",
  "p-m": "awsui_p-m_18wu0_1h82x_649",
  "p-top-m": "awsui_p-top-m_18wu0_1h82x_653",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_1h82x_654",
  "p-right-m": "awsui_p-right-m_18wu0_1h82x_658",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_1h82x_659",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_1h82x_663",
  "p-left-m": "awsui_p-left-m_18wu0_1h82x_668",
  "p-l": "awsui_p-l_18wu0_1h82x_548",
  "p-top-l": "awsui_p-top-l_18wu0_1h82x_677",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_1h82x_678",
  "p-right-l": "awsui_p-right-l_18wu0_1h82x_682",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_1h82x_683",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_1h82x_687",
  "p-left-l": "awsui_p-left-l_18wu0_1h82x_692",
  "p-xl": "awsui_p-xl_18wu0_1h82x_697",
  "p-top-xl": "awsui_p-top-xl_18wu0_1h82x_701",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_1h82x_702",
  "p-right-xl": "awsui_p-right-xl_18wu0_1h82x_706",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_1h82x_707",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_1h82x_711",
  "p-left-xl": "awsui_p-left-xl_18wu0_1h82x_716",
  "p-xxl": "awsui_p-xxl_18wu0_1h82x_721",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_1h82x_725",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_1h82x_726",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_1h82x_730",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_1h82x_731",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_1h82x_735",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_1h82x_740",
  "p-xxxl": "awsui_p-xxxl_18wu0_1h82x_745",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_1h82x_749",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_1h82x_750",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_1h82x_754",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_1h82x_755",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_1h82x_759",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_1h82x_764",
  "m-n": "awsui_m-n_18wu0_1h82x_769",
  "m-top-n": "awsui_m-top-n_18wu0_1h82x_773",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_1h82x_774",
  "m-right-n": "awsui_m-right-n_18wu0_1h82x_778",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_1h82x_779",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_1h82x_783",
  "m-left-n": "awsui_m-left-n_18wu0_1h82x_788",
  "m-xxxs": "awsui_m-xxxs_18wu0_1h82x_793",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_1h82x_797",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_1h82x_798",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_1h82x_802",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_1h82x_803",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_1h82x_807",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_1h82x_812",
  "m-xxs": "awsui_m-xxs_18wu0_1h82x_817",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_1h82x_821",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_1h82x_822",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_1h82x_826",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_1h82x_827",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_1h82x_831",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_1h82x_836",
  "m-xs": "awsui_m-xs_18wu0_1h82x_841",
  "m-top-xs": "awsui_m-top-xs_18wu0_1h82x_845",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_1h82x_846",
  "m-right-xs": "awsui_m-right-xs_18wu0_1h82x_850",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_1h82x_851",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_1h82x_855",
  "m-left-xs": "awsui_m-left-xs_18wu0_1h82x_860",
  "m-s": "awsui_m-s_18wu0_1h82x_865",
  "m-top-s": "awsui_m-top-s_18wu0_1h82x_869",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_1h82x_870",
  "m-right-s": "awsui_m-right-s_18wu0_1h82x_874",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_1h82x_875",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_1h82x_879",
  "m-left-s": "awsui_m-left-s_18wu0_1h82x_884",
  "m-m": "awsui_m-m_18wu0_1h82x_889",
  "m-top-m": "awsui_m-top-m_18wu0_1h82x_893",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_1h82x_894",
  "m-right-m": "awsui_m-right-m_18wu0_1h82x_898",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_1h82x_899",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_1h82x_903",
  "m-left-m": "awsui_m-left-m_18wu0_1h82x_908",
  "m-l": "awsui_m-l_18wu0_1h82x_788",
  "m-top-l": "awsui_m-top-l_18wu0_1h82x_917",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_1h82x_918",
  "m-right-l": "awsui_m-right-l_18wu0_1h82x_922",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_1h82x_923",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_1h82x_927",
  "m-left-l": "awsui_m-left-l_18wu0_1h82x_932",
  "m-xl": "awsui_m-xl_18wu0_1h82x_937",
  "m-top-xl": "awsui_m-top-xl_18wu0_1h82x_941",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_1h82x_942",
  "m-right-xl": "awsui_m-right-xl_18wu0_1h82x_946",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_1h82x_947",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_1h82x_951",
  "m-left-xl": "awsui_m-left-xl_18wu0_1h82x_956",
  "m-xxl": "awsui_m-xxl_18wu0_1h82x_961",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_1h82x_965",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_1h82x_966",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_1h82x_970",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_1h82x_971",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_1h82x_975",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_1h82x_980",
  "m-xxxl": "awsui_m-xxxl_18wu0_1h82x_985",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_1h82x_989",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_1h82x_990",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_1h82x_994",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_1h82x_995",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_1h82x_999",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_1h82x_1004",
  "d-block": "awsui_d-block_18wu0_1h82x_1009",
  "d-inline": "awsui_d-inline_18wu0_1h82x_1012",
  "d-inline-block": "awsui_d-inline-block_18wu0_1h82x_1015",
  "d-none": "awsui_d-none_18wu0_1h82x_1018",
  "f-left": "awsui_f-left_18wu0_1h82x_1023",
  "f-right": "awsui_f-right_18wu0_1h82x_1027"
};
  